module.exports = __webpack_public_path__ + "static/media/createpopulationheardy.5209cf23.png";